import React from 'react';
import FieldSelectAutoComplete from '../configuration/fields/FieldSelectAutoComplete';

export default function IndexTableFiltersPanelSelect(props) {
    const onChange = item => {
        props.onChange({
            text: props.prop.items.find(x => x.value === item).text,
            value: item
        })
    }

    return (
        <div className="filters-panel-input">
            <span title={props.label}>{props.label}</span>
            <span>
                <FieldSelectAutoComplete
                    items={props.prop.items}
                    value={props.value}
                    forceReadable={true}
                    forceNonPortal={true}
                    onChange={onChange}
                />
            </span>
        </div>
    )
}